import React, { useState } from "react";
import "./App.css";
import Expences from "./components/Expense/expences";
import Newexpences from "./components/newexpenses/newexpences";

const expences = [
  { id: 1, title: "book", amount: 345, date: new Date(2002, 3, 13) },
  { id: 2, title: "car", amount: 378, date: new Date(2022, 3, 13) },
  { id: 3, title: "mobile", amount: 454, date: new Date(2017, 3, 13) },
];

function App() {
  const [exp, setexp] = useState(expences);

  const epxData = (data) => {
    setexp([data,...exp]);
  };

  return (
    <div>
      <h1>Expence App</h1>
      <Newexpences epxData={epxData} />
      <Expences expences={exp} />
    </div>
  );
}

export default App;
